export default {
  "推荐": "推荐",
  "推荐到频道": "推荐到频道",
  "正在生成可选封面图，系统会默认选中第一张作为视频封面": "正在生成可选封面图，系统会默认选中第一张作为视频封面",
  "创作时间": "创作时间",
  "品牌 / 甲方": "品牌 / 甲方",
  "作品介绍": "作品介绍",
  "纯文字版": "纯文字版",
  "图文并茂版": "图文并茂版",
  "中文介绍": "中文介绍",
  "英文介绍（选填）": "英文介绍（选填）",
  "英文介绍": "英文介绍",
  "图片相册": "图片相册",
  "+新标签": "+ 新标签",
  "分类和标签": "分类和标签",
  "填写更多标签信息，方便您的作品被更多地浏览和准确地筛选到": "填写更多标签信息，方便您的作品被更多地浏览和准确地筛选到",
  "类别": "类别",
  "+ 选择类别标签": "+ 选择类别标签",
  "选填，最多选择3个": "选填，最多选择3个",
  "最多选择1个": "最多选择1个",
  "最多选择x个": "最多选择{num}个",
  "应用场景": "应用场景",
  "软硬件及工具": "软硬件及工具",
  "上一步": "上一步",
  "请选择创作年份": "请选择创作年份",
  "作品介绍不能为空": "作品介绍不能为空",
  "编辑标签": "编辑标签",
  "填写完整的标签信息将有利于您的作品被更多地浏览": "填写完整的标签信息将有利于您的作品被更多地浏览",
  "软件": "软件",
  "硬件": "硬件",
  "材料": "材料",
  "技术手段及其他工具": "技术手段及其他工具",
  "请选择展示条件": "请选择展示条件",
  "图片格式": "图片格式",

  "拖拽您要上传的视频文件于此": "拖拽您要上传的视频文件于此",
  "或者": "或者",
  "视频支持格式：flv, mpg, mpeg, avi, wmv, mov, asf, rm, rmvb, mkv, mp4": "视频支持格式：flv, mpg, mpeg, avi, wmv, mov, asf, rm, rmvb, mkv, mp4",
  "文件大小：3G以内": "文件大小：3G以内",
  "请确保视频文件在您的电脑设备上可正常播放再进行上传": "请确保视频文件在您的电脑设备上可正常播放再进行上传",
  "基本信息": "基本信息",
  "分类和标签": "分类和标签",
  "商业转化": "商业转化",
  "年份": "年份",
  "月份(选填)": "月份(选填)",
  "请仔细考虑此作品是否愿意开放给所有MANA认证用户进行免费下载；下载的视频将会带有MANA的Logo水印和您的MANA账号昵称，这将有利于您的作品在网络传播，被更多人看见。": "请仔细考虑此作品是否愿意开放给所有MANA认证用户进行免费下载；下载的视频将会带有MANA的Logo水印和您的MANA账号昵称，这将有利于您的作品在网络传播，被更多人看见。",
  "展示条件": "展示条件",
  "选填，可多选": "选填，可多选",
  "适用于室内": "适用于室内",
  "适用于室外": "适用于室外",
  "适用于线上及虚拟空间": "适用于线上及虚拟空间",
  "商业合作方式": "商业合作方式",
  "选填，可多选；以下信息仅用于该作品商业转化的接洽，不会在网站及APP上公开展示，未经创作者确认不会与第三方分享。": "选填，可多选；以下信息仅用于该作品商业转化的接洽，不会在网站及APP上公开展示，未经创作者确认不会与第三方分享。",
  "租赁": "租赁",
  "售卖": "售卖",
  "请选择价格范围": "请选择价格范围",
  "请填写价格或价格范围": "请填写价格或价格范围",
  "定制": "定制",
  "其他": "其他",
  "请填写其他合作方式": "请填写其他合作方式",
  "请选择类别": "请选择类别",
  "最多选择5个": "最多选择5个",
  "请选择此分类下细分标签": "请选择此分类下细分标签",
  "已选择": "已选择",
  "个分类标签": "个分类标签",
  "2万元以下": "2万元以下",
  "0~10万元": "0~10万元",
  "2万元~5万元": "2万元~5万元",
  "5万元~10万元": "5万元~10万元",
  "10万元~30万元": "10万元~30万元",
  "30万元~50万元": "30万元~50万元",
  "50万元~100万元": "50万元~100万元",
  "100万元以上": "100万元以上",
  "自定义价格": "自定义价格",
  "请先完善基本信息": "请先完善基本信息",
  "请先完善前面步骤": "请先完善前面步骤",
  "审核通过发布前仅发布者自己可以查看作品": "审核通过发布前仅发布者自己可以查看作品",
  "数量已达到上限，无法选择": "数量已达到上限，无法选择",
  "分类": "分类",
  "回首页": "回首页",
  "查看作品": "查看作品",
  "数量已达到上限，无法添加": "数量已达到上限，无法添加",
  "您所填写的信息尚未保存": "您所填写的信息尚未保存",
  "确定要离开吗？": "确定要离开吗？",
  "确定": "确定",
  "取消": "取消",

  "技术手段及其他工具": "技术手段及其他工具",
  "为您推荐": "为您推荐",
  "接下来播放": "接下来播放",
  "文章详情": "文章详情",
  "参赛类别最多只能选3个": "参赛类别最多只能选3个",
  "参赛类别最多只能选1个": "参赛类别最多只能选1个",
  "参赛类别最多只能选x个": "参赛类别最多只能选{num}个",
  "后续作品入围后我们将通过邮件和短信告知，敬请留意": "后续作品入围后我们将通过邮件和短信告知，敬请留意",
  "+新增": "+ 新增",


  "使用硬件": "使用硬件",
  "使用材料": "使用材料",
  "收藏成功": "收藏成功",
  "取消收藏成功": "取消收藏成功",
  "制作工具": "制作工具",
  "他们也觉得赞": "他们也觉得赞",
  "还没有成员点赞这件作品哦": "还没有成员点赞这件作品哦",
  "成为第一个赞": "成为第一个赞",
  "热门推荐": "热门推荐",
  "自动播放": "自动播放",
  "嵌入视频": "嵌入视频",
  "复制代码": "复制代码",
  "使用软件": "使用软件",
  "TA的更多作品": "TA的更多作品",
  "即将开始": "即将开始",
  "画质": "画质",
  "超高清": "超高清",
  "高清": "高清",
  "标清": "标清",
  "用户暂未开放该视频下载": "用户暂未开放该视频下载",
  "请搜索或选择国籍": "请搜索或选择国籍",
  "招聘": "招聘",
  "上传时间": "上传时间",
  "广告": "广告",
  "MANA 全球新媒体艺术平台": "MANA 全球新媒体艺术平台",
  "全新版客户端发布 使用更流畅": "全新版客户端发布 使用更流畅",
  "扫码下载APP": "扫码下载APP",

  "每日推荐": "每日推荐",
  "新人必看": "新人必看",
  "最近更新": "最近更新",
  "我的关注": "我的关注",
  "暂无关注的创作者发布的作品，快去关注喜欢的创作者吧！": "暂无关注的创作者发布的作品，快去关注喜欢的创作者吧！",
  "发现创作者": "发现创作者",
  "热门分类": "热门分类",
  "更多": "更多",
  "热门行业": "热门行业",
  "热门应用场景": "热门应用场景",
  "活动推荐": "活动推荐",
  "文章": "文章",
  "MANA学院": "MANA学院",
  "入驻高校": "入驻高校",
  "精选创作者": "精选创作者",
  "最新加入创作者": "最新加入创作者",
  "精选作品": "精选作品",
  "精选文章": "精选文章",
  "精选活动": "精选活动",
  "精选频道": "精选频道",
  "直播": "直播",
  "+ 关注": "+ 关注",
  "登录后即可查看关注的作品": "登录后即可查看关注的作品",
  "视频正在转码中，请耐心等待1～2分钟后再尝试": "视频正在转码中，请耐心等待1～2分钟后再尝试",
  "请输入个人简介及获奖经历": "请输入个人简介及获奖经历",
  "下载资源包": "下载资源包",
  "请选择场景": "请选择场景",
  "点击下载所有资料包": "点击下载所有资料包",
  "点击下载资料包": "点击下载资料包",
  "个点位": "个点位",
  "已选择": "已选择",
  "已选资料包下载": "已选资料包下载",
  "的点位": "的点位",
  "请选择场景以及点位": "请选择场景以及点位",
  "是否公开": "是否公开",
  "公开": "公开",
  "请选择是否公开": "请选择是否公开",
  "确认信息": "确认信息",
  "请仔细核对所要提交的信息是否正确": "请仔细核对所要提交的信息是否正确",
  "视频类型": "视频类型",
  "视频是否公开": "视频是否公开",
  "视频下载": "视频下载",
  "场景及点位": "场景及点位",
  "我已了解并同意本次活动应征条款": "我已了解并同意本次活动应征条款",
  "请先同意本次活动应征条款": "请先同意本次活动应征条款",
  "应征条款": "应征条款",
  "首选投稿分类": "首选投稿分类",
  "单选，必填": "单选，必填",
  "次选投稿分类": "次选投稿分类",
  "单选，选填": "单选，选填",
  "首选投稿分类最多只能选1个": "首选投稿分类最多只能选1个",
  "次选投稿分类最多只能选1个": "次选投稿分类最多只能选1个",
  "已静音播放": "已静音播放",
  "点击恢复音量": "点击恢复音量",
}



// WEBPACK FOOTER //
// ./src/languages/cn/video.js